import React from 'react'
import {wrapDispatch} from 'multireducer'
import {connect} from 'react-redux'
import {inputAnswer, submitAnswer, revealAnswer} from '../../../../redux/modules/content'
import {submitAnswerGrandmaster} from '../../../../redux/modules/grandmaster'
import {toJS} from '../../../../util/ToJS'
import Ask from './Ask'


let VisibleAsk = ({inputAnswer, submitAnswer, revealAnswer, index, ...others}) => {
  const _inputAnswer = (answer) => (inputAnswer(index,answer))
  const _submitAnswer = () => (submitAnswer(index))
  const _revealAnswer = () => (revealAnswer(index))
  return (
    <Ask
      inputAnswer={_inputAnswer}
      submitAnswer={_submitAnswer}
      revealAnswer={_revealAnswer}
      {...others}
    />)
}

const mapDispatchToProps = (dispatch,{as, content}) => {
  const {answerType} = content
  return {
    inputAnswer: (blockIndex, answer) => wrapDispatch(dispatch, as)(inputAnswer(blockIndex, answer, answerType)),
    submitAnswer: (blockIndex) =>  as === 'grandmasterProblem' ? dispatch(submitAnswerGrandmaster(blockIndex)) : wrapDispatch(dispatch, as)(submitAnswer(blockIndex)),
    revealAnswer: (blockIndex) =>  wrapDispatch(dispatch, as)(revealAnswer(blockIndex))
  }
}

VisibleAsk = connect(
  null,
  mapDispatchToProps
)(toJS(VisibleAsk))

export default VisibleAsk



// WEBPACK FOOTER //
// ./src/core/components/interactive-content-blocks/ask/VisibleAsk.js